import QRCode from "react-qr-code";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context";

export default function Scan() {
    const auth = useAuth();
    const user = auth?.user;
    const token = user.access_token;
    const navigate = useNavigate();

    return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '16px' }}>
            <div className="qrCodeBorder">
                <QRCode value={token} />
            </div>
            <button className="modal-close" type="button" onClick={() => navigate('/')}>
                Close
            </button>
        </div>
    );
}
